
export function getRoomsCriterias(criterias, value) {
    return value.venues.rooms && value.venues.rooms.is_tent
        ? criterias.venues.tents
        : criterias.venues.rooms;
}

export function isRoomValueInMeter(name) {
    return name !== 'gauge_seats' && name !== 'gauge_standing';
}

export function roomValue(value, name) {
    const roomsValue = value.venues.rooms;
    return roomsValue ? roomsValue[name] : null;
}